<div class="area-chart">
    <svg viewBox="0 0 200 100"
         preserveAspectRatio="none"
         width="96"
         height="32">
        <g fill="transparent">
            <!-- Line path. -->
            <path stroke="#4284f3"
                  vector-effect="non-scaling-stroke"
                  d="M0,98L8.695652173913043,98L17.391304347826086,100L26.08695652173913,99L34.78260869565217,99L43.47826086956522,99L52.17391304347826,99L60.86956521739131,98L69.56521739130434,98L78.26086956521739,99L86.95652173913044,99L95.65217391304348,99L104.34782608695652,98L113.04347826086956,100L121.73913043478262,99L130.43478260869566,97L139.1304347826087,96L147.82608695652172,100L156.52173913043478,99L165.2173913043478,92L173.91304347826087,60L182.6086956521739,23L191.30434782608697,8L200,0"
        
                  stroke-width="2"></path>

            <!-- Area path. -->
            <!---->
            <path fill="#4284f3"
                  opacity="0.2"
                  d="M1,100L0,98L8.695652173913043,98L17.391304347826086,100L26.08695652173913,99L34.78260869565217,99L43.47826086956522,99L52.17391304347826,99L60.86956521739131,98L69.56521739130434,98L78.26086956521739,99L86.95652173913044,99L95.65217391304348,99L104.34782608695652,98L113.04347826086956,100L121.73913043478262,99L130.43478260869566,97L139.1304347826087,96L147.82608695652172,100L156.52173913043478,99L165.2173913043478,92L173.91304347826087,60L182.6086956521739,23L191.30434782608697,8L200,0L200,100"></path>
            <!---->
        </g>
    </svg>
</div>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/chart/area-chart/area-chart.html